module.exports = __webpack_public_path__ + "img/selected1-min.c143b468.png";